import Vue from "vue";
import currency from "currency.js";

const euro = Vue.mixin({
  methods: {
    euro(payload) {
      var formatted_payload = this.replaceCommaWithDot(payload);
      formatted_payload = formatted_payload * 100;

      const money = currency(formatted_payload, {
        separator: ".",
        decimal: ",",
        fromCents: true,
        symbol: "€",
      }).format();

      return money;
    },
    euroFromCents(payload) {
      const formatted_payload = this.replaceCommaWithDot(payload);
      const money = currency(formatted_payload, {
        separator: ".",
        decimal: ",",
        fromCents: true,
        symbol: "€",
      }).format();
      return this.displayDecimalDash(money);
    },
    euroFromCentsFormatZeroToDash(payload) {
      const formatted_payload = this.replaceCommaWithDot(payload);
      if (formatted_payload === 0) {
        return "-";
      }
      const money = currency(formatted_payload, {
        separator: ".",
        decimal: ",",
        fromCents: true,
        symbol: "€",
      }).format();
      return this.displayDecimalDash(money);
    },
    euroFromCentsWithoutSymbol(payload) {
      const money = currency(payload, {
        separator: ".",
        decimal: ",",
        fromCents: true,
        symbol: "€",
      }).format();
      return money.replace("€", "");
    },
    euroFromCentsWithoutDash(payload) {
      const money = currency(payload, {
        separator: ".",
        decimal: ",",
        fromCents: true,
        symbol: "€",
      }).format();

      return money;
    },
    replaceCommaWithDot(payload) {
      if (payload && typeof payload !== "number" && payload.indexOf(",") > -1) {
        return payload.replace(",", ".");
      }
      return payload;
    },
    setPrice(modal, sourceKey, targetKey) {
      const edit = modal[sourceKey].replace(",", ".") * 100;
      const editArray = String(edit).split(".");
      Vue.set(modal, targetKey, Number(editArray[0]));
    },
    displayDecimalDash(payload) {
      if (payload.substring(payload.length - 2) === "00") {
        return payload.substring(0, payload.length - 2) + "-";
      }

      return payload;
    },
  },
});

export default euro;
